import { useState } from "react"

import useRouter from "@hooks/useRouter"
import useSlugExtractor from "@hooks/useSlugExtractor"

import { faIcon } from "@utils/faIcon"
import generateRandomKey from "@utils/generateRandomKey"

import { LinkButton } from "@atoms"
import { checkIfShouldActiveLink } from "@atoms/NavigationLink/NavigationLink"

import { Select } from "@molecules"
import type { SelectListItem } from "@molecules/Select/SelectListItem/SelectListItem.types"

import NavTopBarBackButton from "@organisms/NavTopBar/NavTopBarBackButton/NavTopBarBackButton"

import { HOME_ROUTE } from "@routes/home"

import styles from "./NavTopBarPageTitle.module.scss"
import { NavTopBarPageTitleProps } from "./NavTopBarPageTitle.types"

export default function NavTopBarPageTitle(props: NavTopBarPageTitleProps) {
    const { label, backDestination, navigationItems, onNavigationItemSelect, avatar } = props

    const [dropdownIsOpen, setDropdownIsOpen] = useState<boolean>(false)

    const hasSubItems = navigationItems && navigationItems.length > 0

    const onSelect = (item: SelectListItem) => {
        onNavigationItemSelect?.(item)
    }

    const router = useRouter()

    const [rootPath] = useSlugExtractor([HOME_ROUTE])

    return (
        <div className={styles.base}>
            {backDestination && <NavTopBarBackButton destination={backDestination} />}
            {avatar && <div className={styles.avatar}>{avatar}</div>}
            {!hasSubItems ? (
                <LinkButton colorScheme="black" className={styles.title} onClick={() => {}} noDebounce={true}>
                    {label}
                </LinkButton>
            ) : (
                <Select.Root isOpen={dropdownIsOpen} onOpenChange={setDropdownIsOpen} mobilePresentation="inline">
                    <Select.Trigger>
                        <LinkButton
                            colorScheme="black"
                            className={styles.title}
                            rightIcon={faIcon({ name: "angles-up-down", style: "regular" })}
                            rightIconClassName={styles.chevron}
                            noDebounce={true}
                            onClick={() => {}}
                            isPressed={dropdownIsOpen}
                        >
                            {label}
                        </LinkButton>
                    </Select.Trigger>
                    <Select.Viewport>
                        <Select.List title={label} className={styles.list}>
                            <Select.ListGroup>
                                {navigationItems?.map((item) => {
                                    return (
                                        <Select.ListItem
                                            key={generateRandomKey()}
                                            variant={item.leading ? "icon" : "default"}
                                            item={item}
                                            isSelected={
                                                item.isActive ??
                                                checkIfShouldActiveLink(item.value, router.pathname, rootPath)
                                            }
                                            onSelect={() => onSelect(item)}
                                        />
                                    )
                                })}
                            </Select.ListGroup>
                        </Select.List>
                    </Select.Viewport>
                </Select.Root>
            )}
        </div>
    )
}
